// src/components/layout/SidebarContext.js

import React, { createContext, useContext, useState } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

const drawerWidth = 220;
const collapsedDrawerWidth = 60;

const SidebarContext = createContext();

export function SidebarContextProvider({ children }) {
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const [drawerOpen, setDrawerOpen] = useState(true);

  const handleDrawerToggle = () => {
    setDrawerOpen((prev) => !prev);
  };

  const sidebarWidth = isSmDown ? 0 : drawerOpen ? drawerWidth : collapsedDrawerWidth;

  return (
    <SidebarContext.Provider
      value={{ drawerOpen, handleDrawerToggle, sidebarWidth, isSmDown, drawerWidth, collapsedDrawerWidth }}
    >
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebarContext() {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebarContext must be used within a SidebarContextProvider');
  }
  return context;
}

export { drawerWidth, collapsedDrawerWidth };
